import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { JSX } from "react";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

export const ProfileTab = (): JSX.Element => {
    const userData = useGetUserInfoQuery();

    const {
        activeLanguage,
        salutation,
        firstName,
        insertion,
        lastName,
        function: functionName,
        email,
        phoneNumber,
    } = userData?.data || { activeLanguage: null };

    const { t, isLoading: isTranslationsLoading } = useStringTranslation();
    const translationsLoaded = !isTranslationsLoading && !!activeLanguage;

    return (
        <div className="c-account-content c-account-content--profile">
            <div className="c-account-content__header">
                {translationsLoaded ? (
                    <h1>{t("personal-information")}</h1>
                ) : (
                    <h1 className="skeleton skeleton-title"></h1>
                )}
            </div>

            <div className="c-account-content__wrapper">
                <div className="c-account-content__column">
                    {translationsLoaded ? (
                        <span className="c-account-content__column__text c-account-content__column__text--label">
                            {t("salutation")}
                        </span>
                    ) : (
                        <span className="c-account-content__column__text c-account-content__column__text--label skeleton skeleton-name"></span>
                    )}

                    {translationsLoaded ? (
                        <>
                            {salutation ? (
                                <span className="c-account-content__column__text">
                                    {salutation}
                                </span>
                            ) : (
                                <span className="c-account-content__column__text">
                                    -
                                </span>
                            )}
                        </>
                    ) : (
                        <span className="c-account-content__column__text skeleton skeleton-name"></span>
                    )}
                </div>

                <div className="c-account-content__column">
                    {translationsLoaded ? (
                        <span className="c-account-content__column__text c-account-content__column__text--label">
                            {t("first-name")}
                        </span>
                    ) : (
                        <span className="c-account-content__column__text c-account-content__column__text--label skeleton skeleton-name"></span>
                    )}

                    {translationsLoaded ? (
                        <>
                            {firstName ? (
                                <span className="c-account-content__column__text">
                                    {firstName}
                                </span>
                            ) : (
                                <span className="c-account-content__column__text">
                                    -
                                </span>
                            )}
                        </>
                    ) : (
                        <span className="c-account-content__column__text skeleton skeleton-name"></span>
                    )}
                </div>

                <div className="c-account-content__column">
                    {translationsLoaded ? (
                        <span className="c-account-content__column__text c-account-content__column__text--label">
                            {t("infix")}
                        </span>
                    ) : (
                        <span className="c-account-content__column__text c-account-content__column__text--label skeleton skeleton-name"></span>
                    )}

                    {translationsLoaded ? (
                        <>
                            {insertion ? (
                                <span className="c-account-content__column__text">
                                    {insertion}
                                </span>
                            ) : (
                                <span className="c-account-content__column__text">
                                    -
                                </span>
                            )}
                        </>
                    ) : (
                        <span className="c-account-content__column__text skeleton skeleton-name"></span>
                    )}
                </div>

                <div className="c-account-content__column">
                    {translationsLoaded ? (
                        <span className="c-account-content__column__text c-account-content__column__text--label">
                            {t("last-name")}
                        </span>
                    ) : (
                        <span className="c-account-content__column__text c-account-content__column__text--label skeleton skeleton-name"></span>
                    )}

                    {translationsLoaded ? (
                        <>
                            {lastName ? (
                                <span className="c-account-content__column__text">
                                    {lastName}
                                </span>
                            ) : (
                                <span className="c-account-content__column__text">
                                    -
                                </span>
                            )}
                        </>
                    ) : (
                        <span className="c-account-content__column__text skeleton skeleton-name"></span>
                    )}
                </div>

                <div className="c-account-content__column">
                    {translationsLoaded ? (
                        <span className="c-account-content__column__text c-account-content__column__text--label">
                            {t("function")}
                        </span>
                    ) : (
                        <span className="c-account-content__column__text c-account-content__column__text--label skeleton skeleton-name"></span>
                    )}
                    {translationsLoaded ? (
                        <>
                            {functionName ? (
                                <span className="c-account-content__column__text">
                                    {functionName}
                                </span>
                            ) : (
                                <span className="c-account-content__column__text">
                                    -
                                </span>
                            )}
                        </>
                    ) : (
                        <span className="c-account-content__column__text skeleton skeleton-name"></span>
                    )}
                </div>

                <div className="c-account-content__column">
                    {translationsLoaded ? (
                        <span className="c-account-content__column__text c-account-content__column__text--label">
                            {t("emailaddresses")}
                        </span>
                    ) : (
                        <span className="c-account-content__column__text c-account-content__column__text--label skeleton skeleton-name"></span>
                    )}

                    {translationsLoaded ? (
                        <>
                            {email ? (
                                <span className="c-account-content__column__text">
                                    {email}
                                </span>
                            ) : (
                                <span className="c-account-content__column__text">
                                    -
                                </span>
                            )}
                        </>
                    ) : (
                        <span className="c-account-content__column__text skeleton skeleton-name"></span>
                    )}
                </div>

                <div className="c-account-content__column">
                    {translationsLoaded ? (
                        <span className="c-account-content__column__text c-account-content__column__text--label">
                            {t("phone-number")}
                        </span>
                    ) : (
                        <span className="c-account-content__column__text c-account-content__column__text--label skeleton skeleton-name"></span>
                    )}
                    {translationsLoaded ? (
                        <>
                            {phoneNumber ? (
                                <span className="c-account-content__column__text">
                                    {phoneNumber}
                                </span>
                            ) : (
                                <span className="c-account-content__column__text">
                                    -
                                </span>
                            )}
                        </>
                    ) : (
                        <span className="c-account-content__column__text skeleton skeleton-name"></span>
                    )}
                </div>
            </div>
        </div>
    );
};
